module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_10.e3abdb91.png";